import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export type DocumentRecencyCheckName = CheckName.DocumentRecencyDetection;

export enum ComparisonDirection {
  OlderThan = 'older_than',
  NewerThan = 'newer_than',
}

export interface DocumentRecencyCheckConfig extends VerificationCheckConfig {
  check: DocumentRecencyCheckName;
  'required-recency-days': number;
  'comparison-direction': ComparisonDirection;
}

export function isDocumentRecencyCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is DocumentRecencyCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.DocumentRecencyDetection:
      return true;
    default:
      return false;
  }
}
